import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const InstitutionalLogosForm = ({ sectionId, itemToEdit, onSuccess, onCancel }) => {
  const isEdit = Boolean(itemToEdit);

  const [formData, setFormData] = useState({
    title: '',
    content: '', 
    item_order: 1
  });

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit && itemToEdit) {
      setFormData({
        title: itemToEdit.title || '',
        content: itemToEdit.description || '', 
        item_order: itemToEdit.item_order || 1
      });
    }
  }, [isEdit, itemToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // --- NOVA FUNÇÃO PARA O EDITOR: Ele não envia 'event', envia só o HTML ---
  const handleEditorChange = (html) => {
    setFormData(prev => ({ ...prev, content: html }));
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  // --- CONFIGURAÇÃO DA BARRA DE FERRAMENTAS DO EDITOR (Rich Text) ---
  const quillModules = {
    toolbar: [
      [{ 'header': [3, 4, false] }],
      ['bold', 'italic', 'underline'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['clean']
    ],
  };

  const quillFormats = [
    'header', 'bold', 'italic', 'underline', 'list', 'bullet'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sectionId) return alert("Erro: ID da seção não encontrado.");
    
    setLoading(true);
    const data = new FormData();
    data.append('section_id', sectionId);
    data.append('title', formData.title);
    data.append('subtitle', '');
    data.append('content', formData.content); // Envia o HTML pronto
    data.append('item_order', formData.item_order);
    data.append('progress_percentage', 0);
    if (file) {
      data.append('carousel_images', file);
    }

    try {
      if (isEdit) {
        await api.put(`/admin/timeline-items/${itemToEdit.id}`, data);
      } else {
        await api.post('/admin/timeline-items', data);
      }
      onSuccess();
    } catch (err) {
      console.error(err);
      alert('Erro ao salvar parceiro.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
        <h5 className="fw-bold text-primary mb-0">
          <i className={`bi ${isEdit ? 'bi-pencil-square' : 'bi-plus-circle'} me-2`}></i> 
          {isEdit ? 'Editar Parceiro' : 'Adicionar Novo Parceiro'}
        </h5>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onCancel}>
          <i className="bi bi-arrow-left me-1"></i> Voltar para Lista
        </button>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label fw-bold small">NOME DO PARCEIRO (TÍTULO)</label>
            <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} required />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold small">ORDEM DE EXIBIÇÃO</label>
            <input type="number" name="item_order" className="form-control" value={formData.item_order} onChange={handleChange} min="1" required />
          </div>
        </div>

        {/* --- CORREÇÃO AQUI: Substituímos o <textarea> pelo ReactQuill --- */}
        <div className="mb-4">
          <label className="form-label fw-bold small">DESCRIÇÃO DO PARCEIRO (Texto Rico)</label>
          <div style={{ height: '200px', marginBottom: '50px' }}> {/* Container para dar altura ao editor */}
            <ReactQuill 
              theme="snow"
              value={formData.content}
              onChange={handleEditorChange} // Função exclusiva
              modules={quillModules}
              formats={quillFormats}
              style={{height: '100%', backgroundColor: 'white'}}
              placeholder="Descreva as qualificações ou o papel deste parceiro no empreendimento. Use ENTER para parágrafos, Negrito, Itálico, etc."
            />
          </div>
        </div>

        <div className="mb-4 p-3 bg-light rounded border">
          <label className="form-label fw-bold small">LOGO OU IMAGEM DO PARCEIRO</label>
          <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
          <div className="form-text mt-2 text-muted">
             Dica: Use arquivos .PNG transparentes para um visual premium.
          </div>
          {isEdit && <div className="form-text text-warning mt-1"><i className="bi bi-exclamation-triangle"></i> Atenção: Enviar uma nova logo substituirá a imagem atual deste parceiro.</div>}
        </div>

        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-primary px-5 fw-bold" disabled={loading}>
            {loading ? 'Processando...' : 'SALVAR PARCEIRO'}
          </button>
          <button type="button" className="btn btn-outline-secondary px-4" onClick={onCancel}>CANCELAR</button>
        </div>
      </form>
    </div>
  );
};

export default InstitutionalLogosForm;